import { render, staticRenderFns } from "./TargetedResumeBuilder.vue?vue&type=template&id=2cbc131a&scoped=true"
import script from "./TargetedResumeBuilder.vue?vue&type=script&lang=js"
export * from "./TargetedResumeBuilder.vue?vue&type=script&lang=js"
import style0 from "./TargetedResumeBuilder.vue?vue&type=style&index=0&id=2cbc131a&prod&scoped=true&lang=css"
import style1 from "./TargetedResumeBuilder.vue?vue&type=style&index=1&id=2cbc131a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc131a",
  null
  
)

export default component.exports